import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { trackHelpCenterEmailClick } from "@faire/web-api/events/helpCenter/click/email";
export var trackEmailUsClickWhenChatInBusinessHours = function trackEmailUsClickWhenChatInBusinessHours(issueType, doNotTrack) {
  var _getUserToken;
  if (doNotTrack) {
    return;
  }
  var userToken = (_getUserToken = getUserToken()) !== null && _getUserToken !== void 0 ? _getUserToken : "";
  trackHelpCenterEmailClick(userToken, userToken, issueType);
};